import { render, staticRenderFns } from "./TaskConfigModal.vue?vue&type=template&id=b6db1792&"
import script from "./TaskConfigModal.vue?vue&type=script&lang=js&"
export * from "./TaskConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskConfigModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports